import ModalChangeAddress from "../ModalChangeAddress";
import "./index.scss";

const InfoReceiverAndSender = ({ infoUser, loadingUpdateCart, refetch }) => {
  const {
    title,
    id,
    name,
    phoneNumber,
    address,
    titleModal,
    list,
    onSubmit,
    addMoreButton,
    paginationData,
    params,
    loadingContactList,
    onTableChange,
    isReceiver,
    handleChangeInput,
    senderAddressVersion,
    shippingAddressVersion,
  } = infoUser;

  return (
    <div className="info-receiver-and-sender">
      <b>{title}</b>
      <div style={{ width: "80%" }}>
        <div
          className={`info-address ${senderAddressVersion === "V1" || shippingAddressVersion === "V1" ? "error-validate-address" : ""}`}
        >
          {" "}
          <div>
            <span>
              <b>{name}</b>
              {phoneNumber ? ` | ${phoneNumber}` : null}
            </span>
            <ModalChangeAddress
              title={titleModal}
              list={list}
              id={id}
              onSubmit={onSubmit}
              loadingButton={loadingUpdateCart}
              addMoreButton={addMoreButton}
              paginationData={paginationData}
              params={params}
              loadingContactList={loadingContactList}
              onTableChange={onTableChange}
              isReceiver={isReceiver}
              handleChangeInput={handleChangeInput}
            />
          </div>
          <span>{address}</span>
        </div>
        {(senderAddressVersion === "V1" || shippingAddressVersion === "V1") && (
          <div style={{ color: "#D2434D", marginTop: "4px", fontSize: "13px" }}>
            Vui lòng chỉnh sửa thông tin nhận hàng theo địa chỉ mới sau sáp nhập để tiếp tục đặt hàng.
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoReceiverAndSender;
